import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export default function StatsCounter({ value, suffix = "", label, duration = 1600, testId, format }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [display, setDisplay] = useState(0);

  const isYear = format === "year";

  useEffect(() => {
    if (!inView) return;
    if (isYear) { setDisplay(value); return; }
    const start = performance.now();
    let raf;
    const step = (t) => {
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(value * eased));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, duration, isYear]);

  const formatted = isYear ? String(display) : (display >= 1000 ? display.toLocaleString("en-IN") : display.toString());

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6 }}
      data-testid={testId}
      className="flex flex-col"
    >
      <div className="font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-shramik-ink leading-none">
        {formatted}<span className="text-shramik-green">{suffix}</span>
      </div>
      <div className="mt-3 text-xs md:text-sm uppercase tracking-[0.2em] text-slate-500 font-semibold">{label}</div>
    </motion.div>
  );
}
